import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public showChat:boolean = false; //ADD INE(JJGJ) 20221018 - REQ22978
  constructor() { }

  ngOnInit() {
  }
  public ModelUsuario: any = JSON.parse(localStorage.getItem("objSesionUsuarioLogeado")); //ADD EXP(WTAI) REQ21135 20211221

  //INICIO: INE(EGB) 20220819 - REQ22111
  hideTerminosCondiciones() {
    $('#modalTerminos').hide();
  }
  //FIN: INE(EGB) 20220819 - REQ22111

}
